<template>
  <member-form
    v-show="showMemberForm"
    ref="memberForm"
    :embedded-in-model-table="false"
    simplify
    @apply-changes="memberFormApplyChanges()"
    @add-model="memberFormApplyChanges()"
  />

  <div
    v-if="user"
    class="q-mt-md q-mb-md"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <q-inner-loading
      v-if="user.loading"
      :showing="true"
    />
    <template v-else>
      <div
        class="col-auto text-label text-left text-h6 q-px-sm"
        :class="$q.screen.lt.sm ? 'q-my-sm' : 'q-my-md'"
      >
        {{ $t('pages.activitySelectTickets.titles.greeting', { name: order.user.firstName, membershipTypesAvailable }) }}
        <span class="text-negative">{{ activity.hasMinimumAttendance ? $t('pages.activitySelectTickets.messages.minimumAttendanceRequired', { minimumAttendance: activity.minimumAttendance }) : '' }}</span>
      </div>
      <div
        class="text-h5 text-left bg-primary q-px-md q-py-sm rounded-borders-8 q-mb-sm"
        :class="$getTextColor(currentSite, 'primary')"
      >
        {{ $tc(membershipTypesAvailable ? 'ticket.memberTicket' : 'ticket.ticket', 2) }}
      </div>
      <div
        v-if="activity.loading"
        class="full-width items-center text-center q-list q-list--bordered q-list--separator"
      >
        <q-spinner size="lg" />
      </div>
      <q-list
        v-else-if="userOrderDatas.user"
        class="full-width rounded-borders-8"
      >
        <q-item
          v-for="userOrderData in $_.concat([userOrderDatas.user], $_.values(userOrderDatas.members))"
          :key="userOrderData.user.id"
          :class="{
            'text-responsive-grey ': !areTicketsAllowed,
            'q-px-sm': $q.screen.lt.sm,
            'column': $q.screen.lt.sm
          }"
          class="rounded-borders-8 borders q-mb-sm"
        >
          <template v-if="userOrderData.ticketTypeOrItemPackage">
            <q-item-section
              v-if="showMemberImages && $register"
              avatar
            >
              <q-img
                class="self-center"
                :src="userOrderData.user.photoUrl"
                :ratio="1"
                height="102px"
                width="102px"
              />
            </q-item-section>
            <q-item-section :style="showMemberImages || $q.screen.lt.lg ? undefined : 'height: 62px;'">
              <div class="row q-gutter-x-xs justify-between">
                <div
                  class="column items-start justify-center col-auto"
                  :class="{ 'q-pr-lg': $q.screen.gt.xs }"
                >
                  <div
                    class="items-center justify-center"
                  >
                    <span
                      class="ellipsis text-body1 text-bold"
                      :class="$q.screen.xs ? 'q-mx-xs' : undefined"
                      :style="{ 'line-height': $q.screen.xs ? '1.2': '1.4' }"
                    >
                      {{ userOrderData.user.firstName !== '' ? userOrderData.user.firstName : userOrderData.user.name }}
                    </span>
                    <div
                      class="row justify-center text-uppercase"
                    >
                      <template v-if="$q.screen.gt.xs && (user && user.id) === userOrderData.user.id && (user.dayPassDate || order.purchasingDayPass)">
                        <q-chip
                          class="ellipsis q-ma-none"
                          square
                          dense
                          color="primary"
                          text-color="white"
                          :label="$t('person.dayPassHolder')"
                        />
                      </template>
                      <template v-else-if="$q.screen.gt.xs && userOrderData.user.membership && !userOrderData.user.membershipType.hide && ( $register || userOrderData.user.membership.state === 'active')">
                        <q-chip
                          class="ellipsis q-mx-none"
                          style="max-width: 115px;"
                          square
                          dense
                          :disable="userOrderData.user.type === USER_TYPES.GUEST && !currentCircuit.allowGuests"
                          :color="userOrderData.user.membership.state === 'active' ? 'primary' : null"
                          :text-color="userOrderData.user.membership.state === 'active' ? 'white' : null"
                          :label="(userOrderData.user.membershipType && userOrderData.user.membershipType.name) + (!!userOrderData.user.membershipTier ? (' - ' + userOrderData.user.membershipTier.name) : '')"
                        />
                        <q-icon
                          v-if="userOrderData.user.membership.state !== 'active' && $register"
                          name="cancel"
                          size="sm"
                          color="negative"
                        />
                      </template>
                    </div>
                  </div>
                </div>
                <div
                  class="col column  justify-center"
                  :class="$q.screen.lt.lg ? 'items-start' : 'items-center'"
                >
                  <q-chip
                    v-if="$_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages).length <= 1"
                    class="ellipsis q-px-xs"
                    square
                  >
                    {{ userOrderData.ticketTypeOrItemPackage.displayName || userOrderData.ticketTypeOrItemPackage.name }}
                  </q-chip>
                  <q-select
                    v-else
                    class="full-width"
                    :class="$q.screen.xs ? 'q-mt-sm q-mb-md' : undefined"
                    :model-value="userOrderData.ticketTypeOrItemPackage.displayName || userOrderData.ticketTypeOrItemPackage.name"
                    :options="$_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages)"
                    :disable="activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)"
                    dense
                    filled
                    :label="$t('pages.activitySelectTickets.labels.viewTicketOptions')"
                    :hint="hint(userOrderData)"
                    @update:model-value="ticketTypeOrItemPackage => userOrderData.ticketTypeOrItemPackage = ticketTypeOrItemPackage"
                  >
                    <template #option="scope">
                      <q-item
                        v-bind="scope.itemProps"
                        v-on="scope.itemEvents"
                      >
                        <q-item-section>
                          {{ scope.opt.typeName === 'ItemPackage' ? scope.opt.name : scope.opt.displayName }}
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                  <div
                    v-if="$q.screen.gt.xs && $_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages).length <= 1"
                    class="text-responsive-grey-8 text-caption"
                    style="line-height: 1.2;"
                  >
                    {{ $t('activityBooking.form.priceVariesByTime', { price: $i18n.n(activityBooking.getFromPrice(userOrderData.ticketTypeOrItemPackage), 'currency') }) }}
                  </div>
                </div>
              </div>
            </q-item-section>
            <q-item-section
              :side="$q.screen.gt.xs"
              :class="{ 'q-mt-sm': $q.screen.lt.sm }"
              :style="{ 'margin-left': $q.screen.lt.sm ? '0' : undefined }"
            >
              <div
                class="row justify-end"
                :style="{ 'min-width': minWidth }"
              >
                <div
                  class="col-auto row items-center justify-center"
                  :class="$q.screen.lt.sm ? 'items-center self-center' : 'items-end'"
                  :style="{ 'min-width': $q.screen.lt.sm ? '100%' : '108px' }"
                >
                  <div
                    v-if="$q.screen.lt.sm"
                    class="col column justify-center items-start q-pr-sm"
                  >
                    <div
                      class="text-body2"
                    >
                      <div
                        class="text-responsive-grey-8 text-caption"
                        style="line-height: 1.2;"
                      >
                        {{ $t('activityBooking.form.priceVariesByTime', { price: $i18n.n(activityBooking.getFromPrice(userOrderData.ticketTypeOrItemPackage), 'currency') }) }}
                      </div>
                    </div>
                  </div>
                  <add-and-remove-button-set
                    :show-add-button="(!activityBooking.isTicketLimitReached || activityBooking.isTicketLimitReached) && !activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)"
                    :show-add-and-remove-buttons="activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData) && !separateTicketAndTime"
                    :quantity="activityBooking.activityUnitQuantity"
                    :item-count-description="$t('activityBooking.form.countMinutes', { count: activityBooking.activity.activityUnitDurationMinutes * activityBooking.activityUnitQuantity })"
                    :add-unavailable="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData))"
                    :increment-disabled="activityBooking.activityUnitQuantity >= activity.maxConsecutiveActivityUnits"
                    :decrement-disabled="activityBooking.activityUnitQuantity <= 0"
                    :square="$register"
                    :outline="$register"
                    :rounded="!$register"
                    @add="activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)
                      ? decrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)
                      : increment(userOrderData.ticketTypeOrItemPackage, userOrderData.user)"
                    @decrement="handleDecrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)"
                    @increment="activityBooking.incrementActivityUnitQuantity()"
                  >
                    <template #tooltip>
                      <q-tooltip
                        v-if="activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)"
                        :offset="[10, 10]"
                      >
                        {{ $t('pages.activitySelectTickets.messages.maxCapacityReached') }}
                      </q-tooltip>
                    </template>
                  </add-and-remove-button-set>
                </div>
              </div>
            </q-item-section>
          </template>
        </q-item>
      </q-list>
      <div
        v-if="$consumer && redeemableVoucherTypes.length > 0 && currentUser"
        class="text-caption text-center q-mt-sm"
      >
        <div
          class="text-bold text-primary"
        >
          {{ currentUser.points }} {{ currentCircuit.rewardsCurrencyName }}
          <q-icon
            style="margin-bottom: 2px;"
            name="info"
          >
            <q-tooltip>
              <span
                v-for="(voucherType, index) in redeemableVoucherTypes"
                :key="voucherType.id"
              >
                <br v-if="index !== 0">{{ voucherType.name + ' (' + voucherType.pointsCost + ' ' + currentCircuit.rewardsCurrencyName + ')' }}
              </span>
            </q-tooltip>
          </q-icon>
        </div>
        <span>{{ $t('checkout.redeemCurrencyPrompt', { rewardsCurrencyName: currentCircuit.rewardsCurrencyName }) }}.</span>
      </div>
    </template>
  </div>

  <component
    :is="((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user ? 'q-expansion-item' : 'div'"
    v-if="user || currentSite.allowAnonymousOrders"
    v-model="expand"
    class="q-mb-sm"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <div
      v-if="$_.isNil(user) && activity.hasMinimumAttendance"
      class="col-auto text-label text-left text-h6 q-px-sm"
      :class="$q.screen.lt.sm ? 'q-my-sm' : 'q-my-md'"
    >
      <span class="text-negative">{{ $t('pages.activitySelectTickets.messages.minimumAttendanceRequiredNoParentheses', { minimumAttendance: activity.minimumAttendance }) }}</span>
    </div>
    <div
      v-if="!(((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user)"
      class="text-h5 text-left bg-primary q-px-md q-py-sm rounded-borders-8 q-mb-sm"
      :class="$getTextColor(currentSite, 'primary')"
    >
      {{ order.user ? $t('pages.activitySelectTickets.titles.additionalTickets'): $tc('ticket.ticket', 2) }}
      <div v-if="!$register && activity.loading">
        <q-spinner />
      </div>
    </div>
    <template #header>
      <div
        class="text-h6 text-left"
        :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
      >
        {{ $t('pages.activitySelectTickets.titles.additionalTickets') }}
      </div>
    </template>
    <div v-if="activity.loading">
      <q-spinner />
    </div>
    <q-list
      separator
      class="full-width"
    >
      <div
        v-if="activityBooking.guestTicketTypesOrItemPackages.length === 0"
        class="q-mt-md q-mb-md text-subtitle2 justify-center row"
      >
        {{ $t('pages.activitySelectTickets.messages.noTicketsAvailable') }}
      </div>
      <q-item
        v-for="ticketTypeOrItemPackage in activityBooking.guestTicketTypesOrItemPackages"
        :key="getKeyForTicketTypeOrItemPackage(ticketTypeOrItemPackage)"
        class="rounded-borders-8 borders q-mb-sm"
        :class="{
          'text-responsive-grey ': !areTicketsAllowed,
          'q-px-sm': $q.screen.lt.sm,
          'column': $q.screen.lt.sm
        }"
      >
        <q-item-section>
          <div
            class="row"
          >
            <div
              v-if="isItemPackage(ticketTypeOrItemPackage)"
              class="col-auto column items-start justify-center"
            >
              <div
                class="text-body1 text-bold"
              >
                {{ ticketTypeOrItemPackage.name }}
              </div>
              <div
                class="text-responsive-grey-7 text-caption"
              >
                <div
                  v-for="ticketType in ticketTypeOrItemPackage.ticketTypeDescriptions"
                  :key="ticketType.id"
                >
                  {{ `${ticketType.description} (${$tc('ticket.activityTicket', 1)})` }}
                </div>
                <div
                  v-for="itemVariation in ticketTypeOrItemPackage.itemVariationDescription"
                  :key="itemVariation.id"
                >
                  {{ itemVariation.name }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="col-auto column items-start justify-center"
            >
              <div
                class="row items-center justify-center q-gutter-x-xs"
              >
                <span
                  class="text-body1 text-bold"
                >
                  {{ ticketTypeOrItemPackage.displayName }}
                </span>
                <span
                  v-if="ticketTypeOrItemPackage.userClass"
                  class="text-body1 parentheses"
                  style="line-height: 1.1;"
                >
                  {{ ticketTypeOrItemPackage.userClass.description || ticketTypeOrItemPackage.userClass.ageDescription }}
                </span>
              </div>
            </div>
            <div
              v-if="$q.screen.gt.xs"
              class="col column justify-center items-start q-pl-md q-pr-lg"
            >
              <div
                class="text-body1"
              >
                <div
                  class="text-responsive-grey-8"
                  style="line-height: 1.2;"
                >
                  {{ $t('activityBooking.form.priceVariesByTime', { price: $i18n.n(activityBooking.getFromPrice(ticketTypeOrItemPackage), 'currency') }) }}
                </div>
              </div>
            </div>
          </div>
        </q-item-section>

        <q-item-section
          :side="$q.screen.gt.xs"
          :class="{ 'q-mt-sm': $q.screen.lt.sm }"
          :style="{ 'margin-left': $q.screen.lt.sm ? '0' : undefined }"
        >
          <div
            class="row justify-end text-responsive"
            :style="{ 'min-width': minWidth }"
          >
            <div
              v-if="$q.screen.lt.sm"
              class="col column justify-center items-start q-pr-sm"
            >
              <div
                class="text-body2"
              >
                <div
                  class="text-responsive-grey-8 text-caption"
                  style="line-height: 1.2;"
                >
                  {{ $t('activityBooking.form.priceVariesByTime', { price: $i18n.n(activityBooking.getFromPrice(ticketTypeOrItemPackage), 'currency') }) }}
                </div>
              </div>
            </div>
            <div
              class="col-auto row"
              :class="$q.screen.lt.sm ? 'justify-end items-center self-center' : 'justify-center items-end'"
              :style="{ 'min-width': $q.screen.lt.lg ? '98px' : '108px' }"
            >
              <add-and-remove-button-set
                v-if="activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage) && !separateTicketAndTime"
                :show-add-button="!activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)"
                :quantity="activityBooking.guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage)"
                :item-count-description="$t('activityBooking.form.countMinutes', { count: activityBooking.activity.activityUnitDurationMinutes * activityBooking.activityUnitQuantity })"
                :add-unavailable="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))"
                :increment-disabled="activityBooking.activityUnitQuantity >= activity.maxConsecutiveActivityUnits"
                :decrement-disabled="activityBooking.activityUnitQuantity <= 0"
                :square="$register"
                :outline="$register"
                :rounded="!$register"
                @add="(activityBooking.isTicketLimitReached && activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))
                  ? decrement(ticketTypeOrItemPackage)
                  : increment(ticketTypeOrItemPackage)"
                @decrement="handleDecrement(ticketTypeOrItemPackage)"
                @increment="activityBooking.incrementActivityUnitQuantity()"
              >
                <template #increment-tooltip>
                  <q-tooltip
                    v-if="activityBooking.isTicketLimitReached"
                    :offset="[10, 10]"
                  >
                    {{ $t('pages.activitySelectTickets.messages.maxCapacityReached') }}
                  </q-tooltip>
                </template>
              </add-and-remove-button-set>
              <add-and-remove-button-set
                v-else
                :show-add-button="!activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)"
                :quantity="activityBooking.guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage)"
                :item-count-description="activityBooking.guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage)"
                :add-unavailable="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))"
                :increment-disabled="activityBooking.isTicketLimitReached"
                :decrement-disabled="!activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)"
                :square="$register"
                :outline="$register"
                :rounded="!$register"
                @add="(activityBooking.isTicketLimitReached && activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))
                  ? decrement(ticketTypeOrItemPackage)
                  : increment(ticketTypeOrItemPackage)"
                @decrement="handleDecrement(ticketTypeOrItemPackage)"
                @increment="increment(ticketTypeOrItemPackage)"
              >
                <template #increment-tooltip>
                  <q-tooltip
                    v-if="activityBooking.isTicketLimitReached"
                    :offset="[10, 10]"
                  >
                    {{ $t('pages.activitySelectTickets.messages.maxCapacityReached') }}
                  </q-tooltip>
                </template>
              </add-and-remove-button-set>
            </div>
          </div>
        </q-item-section>
      </q-item>
    </q-list>
  </component>
  <div
    v-if="separateTicketAndTime"
    class="q-mb-md"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <div
      v-if="activity.loading"
      class="full-width items-center text-center q-list q-list--bordered q-list--separator"
    >
      <q-spinner size="lg" />
    </div>
    <q-list
      separator
      class="full-width borders rounded-borders-8"
    >
      <q-item>
        <div class="full-width">
          <div class="row">
            <div
              class="col column items-start justify-center"
            >
              <div
                class="row items-center justify-center q-gutter-x-xs"
              >
                <span
                  class="text-body1 text-bold"
                >
                  {{ $_.startCase(activity.activityUnitDescription) }}
                </span>
              </div>
            </div>
            <add-and-remove-button-set
              :show-add-button="!activityBooking.numSelectedTickets"
              :quantity="activityBooking.activityUnitQuantity"
              :item-count-description="$t('activityBooking.form.countMinutes', { count: activityBooking.activity.activityUnitDurationMinutes * activityBooking.activityUnitQuantity })"
              :add-unavailable="!activityBooking.numSelectedTickets"
              :increment-disabled="activityBooking.activityUnitQuantity >= activity.maxConsecutiveActivityUnits"
              :decrement-disabled="activityBooking.activityUnitQuantity <= 1"
              :square="$register"
              :outline="$register"
              :round="!$register"
              @add="activityBooking.incrementActivityUnitQuantity()"
              @decrement="activityBooking.decrementActivityUnitQuantity()"
              @increment="activityBooking.incrementActivityUnitQuantity()"
            />
          </div>
        </div>
      </q-item>
    </q-list>
  </div>
</template>

<script>
import { useRemoveOrderItem } from 'src/composables/order/order-items/RemoveOrderItem'
import { SESSION_ADMISSION_TYPES } from 'src/models/activity/Activity'
import ActivityBooking from 'src/models/activity/ActivityBooking'
import { ORDER_ITEM_STATES } from 'src/models/order-item/OrderItem'
import { USER_TYPES } from 'src/models/user/User'
import AddAndRemoveButtonSet from 'src/modules/checkout/components/AddAndRemoveButtonSet.vue'
import MemberForm from 'src/modules/register/membership/MemberForm'
import { watchEffect } from 'vue'
export default {
  name: 'ActivitySelectTickets',
  components: {
    MemberForm,
    AddAndRemoveButtonSet
  },
  inject: ['order', 'checkoutData'],
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    }
  },
  context: ['currentUser'],
  configuration: ['currentSite', 'currentCircuit', 'membershipTypes', 'voucherTypes'],
  setup () {
    const { removeOrderItem } = useRemoveOrderItem()
    return {
      removeOrderItem
    }
  },
  data () {
    return {
      editingUser: null,
      showMemberForm: false,
      userOrderDatas: {},
      expand: false
    }
  },
  computed: {
    areTicketsAllowed () {
      return !this.currentSite.membershipRequired || (this.user?.membership?.effective && this.user?.unlimitedMembershipTicketVoucherTypes.length > 0)
    },
    membershipTypesAvailable () {
      return !!_.find(this.membershipTypes.data, membershipType => {
        return !membershipType.default && !membershipType.hide && membershipType.availableOnline
      })
    },
    minWidth () {
      if (this.$kiosk) return '300px'
      if (this.$q.screen.xs) return '170px'
      if (this.$q.screen.lt.lg) return '100px'
      return '300px'
    },
    redeemableVoucherTypes () {
      return _.sortBy(_.filter(this.voucherTypes.data, voucherType => {
        return voucherType.isReward && voucherType.pointsCost <= this.currentUser.points
      }), 'pointsCost')
    },
    showMemberImages () {
      return this.$register && this.user && _(this.userOrderDatas.member).values().every(({ user }) => user.hasPhoto)
    },
    activity () {
      return this.activityBooking.activity
    },
    user () {
      return this.order.user
    },
    separateTicketAndTime () {
      return this.activity.sessionAdmissionType === SESSION_ADMISSION_TYPES.ACTIVITY_UNIT_DYNAMIC
    }
  },
  watch: {
    'activity.loading' () {
      if (this.activity?.loading === false) {
        this.computeUserOrderDatas()
      }
    },
    'user.loading' () {
      if (this.user?.loading === false) {
        this.computeUserOrderDatas()
      }
    }
  },
  created () {
    _.extend(this, { SESSION_ADMISSION_TYPES, USER_TYPES })
  },
  mounted () {
    this.computeUserOrderDatas()

    if (_.isNil(this.checkoutData)) return

    this.stopWatch = watchEffect(() => {
      this.checkoutData.showLoading = this.loading
      this.checkoutData.purchasingMembership = false

      this.checkoutData.stepTitle = this.activity.name
      this.checkoutData.showActivityCard = true
      this.checkoutData.showMovieCard = false
      this.checkoutData.showCartControls = true
      this.checkoutData.showCheckoutFooter = true

      this.checkoutData.expandDefault = false
      this.checkoutData.expandActivityItems = false
      this.checkoutData.expandConcessions = false
      this.checkoutData.expandTickets = false
      this.checkoutData.expandActivityTickets = true

      this.checkoutData.infoTitle = this.$i18n.t('checkout.infoTitles.tickets')
      this.checkoutData.info = this.$i18n.tc('ticket.ticketCount', this.order.activityTicketOrderItems.length)
      this.checkoutData.showInfo = true
      this.checkoutData.showSubtotal = true
      this.checkoutData.showTotals = false

      this.checkoutData.showEmptyCartNextLabel = true

      this.checkoutData.canProceed = this.activityBooking.areMinimumAttendanceRequirementsMet
    })
  },
  unmounted () {
    this.stopWatch?.()
  },
  methods: {
    computeUserOrderDatas () {
      if (this.user?.loading === false && this.activity.loading === false) {
        this.userOrderDatas = this.order.getTicketTypesAndItemPackagesForUserAndPurchasableMembers(
          this.user,
          this.activity,
          this.activityBooking.activityTicketOrderItems
        )
      } else {
        this.userOrderDatas = {}
      }
    },
    decrement (ticketTypeOrItemPackage, user = null) {
      let lastAddedOrderItem = null

      if (ticketTypeOrItemPackage.typeName === 'ItemPackage') {
        lastAddedOrderItem = _.findLast(this.order.draftOrderItems, orderItem => {
          if (orderItem.state !== ORDER_ITEM_STATES.DRAFT) return false
          if (orderItem.itemPackageId !== ticketTypeOrItemPackage.id) return false
          if (orderItem.activityTicket?.activityBookingId !== this.activityBooking.id) return false
          if (orderItem.activityTicket?.user?.id !== user?.id) return false

          return true
        })
      } else {
        lastAddedOrderItem = _.findLast(this.order.draftOrderItems, orderItem => {
          if (orderItem.state !== ORDER_ITEM_STATES.DRAFT) return false
          if (!_.isNil(orderItem.itemPackageId)) return false
          if (orderItem.activityTicket?.ticketTypeId !== ticketTypeOrItemPackage.id) return false
          if (orderItem.activityTicket?.activityBookingId !== this.activityBooking.id) return false
          if (orderItem.activityTicket?.user?.id !== user?.id) return false

          return true
        })
      }

      if (!_.isNil(lastAddedOrderItem)) {
        this.removeOrderItem(lastAddedOrderItem)
      }
      this.activityBooking.resetActivitySessionData()
    },
    getKeyForTicketTypeOrItemPackage (ticketTypeOrItemPackage) {
      return `${ticketTypeOrItemPackage.constructor.name}-${ticketTypeOrItemPackage.id}`
    },
    increment (ticketTypeOrItemPackage, user) {
      if (user?.type === USER_TYPES.GUEST && !this.currentCircuit.allowGuests) {
        this.editingUser = user
        this.$refs.memberForm.show(user)
        this.showMemberForm = true
        return
      }

      this.activityBooking.increment(ticketTypeOrItemPackage, user)
    },
    isItemPackage (ticketTypeOrItemPackage) {
      return ticketTypeOrItemPackage.constructor.name === 'ItemPackage'
    },
    memberFormApplyChanges () {
      this.editingUser.save()
      this.showMemberForm = false
    },
    hint (userOrderData) {
      if (this.$q.screen.lt.sm) return undefined

      const totalTypes = _.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages)
      const count = totalTypes.length
      const countMsg = this.$t('pages.activitySelectTickets.messages.numTicketTypesAvailable', { count })

      if (count > 1) {
        const fromPrice = this.activityBooking.getFromPrice(userOrderData.ticketTypeOrItemPackage)
        const priceMsg = this.$t('activityBooking.form.priceVariesByTime', {
          price: this.$i18n.n(fromPrice, 'currency')
        })
        return `${countMsg}, ${priceMsg}`
      }

      return countMsg
    },
    handleDecrement (ticketTypeOrItemPackage, user = null) {
      if (this.activityBooking.activityUnitQuantity > 1) {
        this.activityBooking.decrementActivityUnitQuantity()
      } else {
        this.decrement(ticketTypeOrItemPackage, user)
      }
    }
  }
}
</script>
